/**
 * components/fiscal/UraTaxCategoriesTable.js
 * ----------------------------------------------------------------------------
 * Every URA tax category code, and which of Lusuku's product VAT categories
 * files under each. URA asked during the UAT that all of them be displayable,
 * since a supply can fall in any of them.
 *
 * The rows are the server's (services/fiscal/uraTaxCategories.js, delivered on
 * GET /api/fiscal-classification/meta as `taxCategories`), never a copy kept
 * here, so the page cannot disagree with the table the server documents.
 */
import React from "react";
import { Table } from "react-bootstrap";
import { TYPE } from "./fiscalUi.js";

const PRODUCT_LABEL = Object.freeze({
  STANDARD: "Standard",
  ZERO_RATED: "Zero rated",
  EXEMPT: "Exempt",
});

const rateText = (row) => {
  if (row.rateRule === "REFUSED") return "Refused by URA";
  if (row.rate !== null && row.rate !== undefined) return row.rate;
  return row.rateNameRequired ? "Stated per line, with a rate name" : "Stated per line";
};

const UraTaxCategoriesTable = ({ categories }) => {
  if (!Array.isArray(categories) || categories.length === 0) return null;
  return (
    <div className="lk-table-frame" data-testid="ura-tax-categories">
      <Table responsive className="lk-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>URA category</th>
            <th>Rate on the document</th>
            <th>Lusuku products filed under it</th>
            <th>On Lusuku</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((row) => (
            <tr key={row.code} data-testid="ura-tax-category">
              <td style={TYPE.code}>
                {row.code}{row.letter ? ` (${row.letter})` : ""}
              </td>
              <td style={{ fontWeight: 600 }}>{row.name}</td>
              <td style={{ whiteSpace: "nowrap" }}>{rateText(row)}</td>
              <td>
                {row.lusukuCategories?.length
                  ? row.lusukuCategories.map((c) => PRODUCT_LABEL[c] || c).join(", ")
                  : <span style={{ color: "#8595a8" }}>None</span>}
              </td>
              <td style={{ color: "#51637a" }}>{row.onLusuku}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default UraTaxCategoriesTable;
